import React from 'react';
import CableInsulationReport from '../CommissioningCableInsulation/CableInsulationReport';

// Thin wrapper around the shared cable-insulation report, fixed to the post-insulation variant.
export default function CommissioningCablePostInsulationReport (props) {
  return <CableInsulationReport variant='post' {...props} />;
}
